import { ChangeDetectorRef, Component, NgZone, ViewChild } from '@angular/core';
import { MenuController, IonInfiniteScroll, LoadingController, ModalController, ActionSheetController, Platform, ToastController, IonVirtualScroll, IonContent } from '@ionic/angular';
import { BasePage } from 'src/pages/base.page';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingComponent } from 'projects/core/src/lib/core/Loading.component';
import { RecomendacaoModel } from 'projects/core/src/lib/core/model/RecomendacaoModel';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { ListaRecomendacoesViewModel } from './ListaRecomendacoesViewModel';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { DataUtil } from 'projects/core/src/lib/core/DataUtil';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { AppStorage } from 'projects/core/src/lib/core/AppStorage';
import { BottomDrawerComponent } from 'src/app/components/bottom-drawer/bottom-drawer.component';
import { PurchaseRecommendationsComponent } from 'src/app/components/purchase-recommendations/purchase-recommendations.component';
import { Subject } from 'rxjs';
import { RecomendacaoMenuModel } from 'projects/core/src/lib/core/model/RecomendacaoMenuModel';
import { ChaveContratoEnum } from 'projects/core/src/lib/core/ChaveContratoEnum';
import { ContratoMenuModel } from 'projects/core/src/lib/core/model/ContratoMenuModel';
import { HelperMenuContrato } from 'projects/core/src/lib/core/HelperMenuContrato';
import { NavegaTelaPlanoImpl } from 'src/pages/plano-ios/NavegaTelaPlanoImpl';
import { ContratoWrapperModel } from 'projects/core/src/lib/core/model/ContratoWrapperModel';
import { PlanoDialog } from 'src/pages/plano/plano.dialog';
import { ContratoModel } from 'projects/core/src/lib/core/model/ContratoModel';
import { Location } from '@angular/common';

enum Tipos {
  "curto" = 1,
  "medio" = 2,
  "longo" = 3,
  "todas" = 4,
}

enum Recomedacoes {
  'B' = 'Ações Brasil',
  'EUA' = 'Ações EUA',
  'C' = 'Criptoativos',
  'FII' = 'FIIs',
  'ETF' = 'ETFs',
  'INDICE' = 'Índices',
  'BDR' = 'BDRs'
}

@Component({
  selector: 'lista-recomendacoes-page',
  templateUrl: 'lista-recomendacoes.page.html',
  styleUrls: ['lista-recomendacoes.page.scss']
})
export class ListaRecomendacoesPage extends BasePage implements NavegaTelaPlanoImpl {

  @ViewChild('drawer') drawer: BottomDrawerComponent;
  @ViewChild('recommendations') recommendations: PurchaseRecommendationsComponent;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  @ViewChild(IonVirtualScroll) virtualScroll: IonVirtualScroll;
  @ViewChild(IonContent) content: IonContent;

  idTipoRecomendacao: number = 1
  primeiraRequisicao = [false, false, false, false, false]

  tituloPagina: String = ""
  filtroEncerradas: String = ""

  TIPO_CURTO = "curto"
  TIPO_MEDIO = "medio"
  TIPO_LONGO = "longo"
  TIPO_TODAS = "todas"
  TIPO_ENCERRADAS = "encerradas"

  STATUS_ABERTO = 'aberto'
  STATUS_ENCERRADO = 'encerrado'

  aba = this.TIPO_TODAS
  drawerState

  favoritos = []
  recomendacaoCurto: Array<RecomendacaoModel> = []
  recomendacaoMedio: Array<RecomendacaoModel> = []
  recomendacaoLongo: Array<RecomendacaoModel> = []
  recomendacaoTodas: Array<RecomendacaoModel> = []

  recomendacaoCompra: Array<RecomendacaoModel> = []
  recomendacaoVenda: Array<RecomendacaoModel> = []
  recomendacaoEncerrados: Array<RecomendacaoModel> = []

  recomendacoesViewModel: ListaRecomendacoesViewModel
  loadingComponent: LoadingComponent
  alertComponent: AlertComponent
  loading: HTMLIonLoadingElement
  data: any
  requestSwipUp: Boolean = false
  tipoAtivo: string = RecomendacaoMenuModel.TIPO_ACOES_BOLSA
  idAtivo = new Subject<number>()
  contratoWrapper: ContratoWrapperModel
  push = false
  constanteContrato = [{
    tipoAtivo: RecomendacaoMenuModel.TIPO_ACOES_BOLSA,
    chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_ACOES]
  }, {
    tipoAtivo: RecomendacaoMenuModel.TIPO_EUA,
    chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_EUA]
  }, {
    tipoAtivo: RecomendacaoMenuModel.TIPO_CRIPTOMOEDAS,
    chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_CRIPTOMOEDAS]
  }, {
    tipoAtivo: RecomendacaoMenuModel.TIPO_FUNDOS_IMOBILIARIOS,
    chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_FUNDOS_IMOBILIARIOS]
  }, {
    tipoAtivo: RecomendacaoMenuModel.TIPO_FUNDOS_INDICE,
    chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_FUNDOS_INDICES]
  }, {
    tipoAtivo: RecomendacaoMenuModel.TIPO_INDICES,
    chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_INDICES]
  }, {
    tipoAtivo: RecomendacaoMenuModel.TIPO_BDR,
    chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_BDR]
  }]

  listaAnaliseAtivosViewMap = {};

  listaAnaliseAtivosView = [];//0=B, 1=EUA, 2=C

  constructor(
    private location: Location,
    private zone: NgZone,
    public router: Router,
    private menuCtrl: MenuController,
    private modalCtrl: ModalController,
    private actionSheetController: ActionSheetController,
    public loadingController: LoadingController,
    private changeDetectorRef: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    public toastCtrl: ToastController,
    private platform: Platform
  ) {
    super(router)
  }

  async ngOnInit() {
    super.ngOnInit()
    this.iniciarVariaveis()
    this.limpaNotificacoesLocal()

    this.listaAnaliseAtivosView[0] = []
    this.listaAnaliseAtivosView[1] = []
    this.listaAnaliseAtivosView[2] = []
    this.listaAnaliseAtivosView[3] = []
    this.listaAnaliseAtivosView[4] = []

    let el = this
    el.platform.ready().then(() => {
      el.platform.pause.subscribe(() => {
        el.recomendacoesViewModel.finishWebSocket()
      });
      el.platform.resume.subscribe(async () => {
        if(el.router.url.startsWith('/navigation/recomendacoes')) {
          el.zone.run(async () => {
            this.handlerStartWebSocket(true)
          });
        }
      });
    });
  }

  // async ionViewDidLeave() {
  //   await this.recomendacoesViewModel.setPreferenciaUsuario(this.tipoAtivo)
  // }

  async ionViewWillEnter() {
    // this.location.replaceState(`/navigation/recomendacoes/default`);
    console.log('Entrou em Recomendações');

    this.resetAll()

    
    await this.handlerStartWebSocket(true)
    this.recomendacoesViewModel.buscaContratos()
    await this.getExtras()
  }

  async handlerStartWebSocket(instanciaWebsocket = false) {
    if (instanciaWebsocket) {
      this.recomendacoesViewModel.finishWebSocket();
      await this.recomendacoesViewModel.initWebSocket(async () => {
        await this.recomendacoesViewModel.sendMessageSocketByTipoAtivo(this.getListaCodigoAtivos())
      });
    } else {
      await this.recomendacoesViewModel.sendMessageSocketByTipoAtivo(this.getListaCodigoAtivos())
    }
  }

  async ionViewWillLeave() {
    this.handleOpenDrawer()
    this.recomendacoesViewModel.finishWebSocket()
  }

  private handleOpenDrawer() {
    this.drawer.state === 'top'
      && this.drawer.toggleDrawer();
  }

  async btnAbrirAtivo(idRecomendacao: number) {
    this.idAtivo.next(idRecomendacao)
    this.drawer.toggleDrawer()
  }

  async getExtras() {
    await this.recomendacoesViewModel.buscaContratos()

    const idAtivo = Number.parseInt(this.activatedRoute.snapshot.paramMap.get('idAtivo'));

    if (idAtivo) {
      this.push = true;
      this.btnAbrirAtivo(idAtivo)
    }

    const ativo = this.activatedRoute.snapshot.paramMap.get('tipoAtivo');
    console.log(ativo);

    if (ativo === 'default') {
      let preferencia = await this.recomendacoesViewModel.getPreferenciaUsuario();
      if (preferencia) {
        this.tipoAtivo = preferencia;
      }

      this.tipoAtivo = this.retornaTipoAtivoPermitido()
      await this.validaPermissaoFuncionalidade()
      return;
    }
    console.log(ativo);

    this.tipoAtivo = ativo;
    this.tipoAtivo = this.retornaTipoAtivoPermitido()
    await this.validaPermissaoFuncionalidade()
  }

  toUpperLowerCase(text: String) {
    let aux = String(text).toLowerCase()
    if (aux.length > 0) {
      aux = aux.substr(0, 1).toUpperCase() + aux.substr(1, aux.length - 1)
    }
    return aux
  }

  async iniciarVariaveis() {
    this.loadingComponent = new LoadingComponent(this.loadingController)
    this.recomendacoesViewModel = new ListaRecomendacoesViewModel()
    this.recomendacoesViewModel.setContext(this)
  }

  private retornaTipoAtivoPermitido(): string {
    for (let i in this.constanteContrato) {
      if (this.constanteContrato[i].tipoAtivo == this.tipoAtivo && this.verificaPermissaoFeature(this.constanteContrato[i])) {
        return this.tipoAtivo
      }
    }

    for (let i in this.constanteContrato) {
      if (this.verificaPermissaoFeature(this.constanteContrato[i])) {
        return this.constanteContrato[i].tipoAtivo
      }
    }
    throw Error()
  }

  setListaContratos(contratoWrapper: ContratoWrapperModel) {
    this.contratoWrapper = contratoWrapper
  }

  async updateDrawerState(newState: string) {
    this.drawerState = newState;
    if (newState != "top") {
      this.recommendations.PurchaseRecommentationsViewModel.finishWebSocket()

      this.recomendacoesViewModel.resetOffset()

      this.listaAnaliseAtivosView[0] = []
      this.listaAnaliseAtivosView[1] = []
      this.listaAnaliseAtivosView[2] = []
      this.listaAnaliseAtivosView[3] = []

      this.recomendacaoCurto = []
      this.recomendacaoMedio = []
      this.recomendacaoLongo = []
      this.recomendacaoTodas = []

      await this.requisitaPorAba(this.aba, this.aba != this.TIPO_ENCERRADAS)
    }
    this.changeDetectorRef.detectChanges();
  }

  async showToast(message: string) {
    let toast = await this.toastCtrl.create({
        message,
        duration: 3000,
        position: 'top'
    });
    toast.present();
  }

  async navegaTelaPlano(urlContratar) {
    const modalBoasVindas = await this.modalCtrl.create({
      component: PlanoDialog,
      componentProps: {
        urlContratar
      }
    });
    modalBoasVindas.present();
  }

  async validaPermissaoFuncionalidade() {
    let loading = null;
    try {
      loading = await this.showLoading()

      let chaveContrato;

      switch (this.tipoAtivo) {
        case RecomendacaoMenuModel.TIPO_ACOES_BOLSA:
          chaveContrato = ChaveContratoEnum.CONTRATO_RECOMENDACAO_ACOES
          break;
        case RecomendacaoMenuModel.TIPO_CRIPTOMOEDAS:
          chaveContrato = ChaveContratoEnum.CONTRATO_RECOMENDACAO_CRIPTOMOEDAS
          break;
        case RecomendacaoMenuModel.TIPO_FUNDOS_IMOBILIARIOS:
          chaveContrato = ChaveContratoEnum.CONTRATO_RECOMENDACAO_FUNDOS_IMOBILIARIOS
          break;
        case RecomendacaoMenuModel.TIPO_FUNDOS_INDICE:
          chaveContrato = ChaveContratoEnum.CONTRATO_RECOMENDACAO_FUNDOS_INDICES
          break;
        case RecomendacaoMenuModel.TIPO_INDICES:
          chaveContrato = ChaveContratoEnum.CONTRATO_RECOMENDACAO_INDICES
          break;
        case RecomendacaoMenuModel.TIPO_EUA:
          chaveContrato = ChaveContratoEnum.CONTRATO_RECOMENDACAO_EUA
          break;
        case RecomendacaoMenuModel.TIPO_BDR:
          chaveContrato = ChaveContratoEnum.CONTRATO_RECOMENDACAO_BDR
          break;
      }

      let item: ContratoMenuModel = {
        active: true,
        chaveContrato: [chaveContrato],
        nivelRestricao: ContratoMenuModel.NIVEL_RESTRICAO_ALTO
      }

      if (!HelperMenuContrato.validaMenu(item)) {
        this.openPage('/navigation/home')
      } else {
        await this.buscaTodosOsDados()
      }
    } catch (e) {
      //this.showAlert(ThrowError.TITLE_DEFAULT, 'Não foi possível obter as informações no momento. Tente novamente')
    }
    if (loading != null) {
      loading.dismiss()
    }
  }

  openHome() {
    this.openPage('/navigation/home')
  }

  itemDividerHeaderFavoritos(record, recordIndex, records) {
    if (recordIndex == 0 && record.favorito) {
      return 1;
    } else if (recordIndex > 0 && records[recordIndex - 1].favorito && !record.favorito) {
      return 2
    }
    return null;
  }

  async buscaTodosOsDados() {
    await this.requisitaPorAba(this.aba)
  }

  formataData(data: String): String {
    try {
      var literalMes = DataUtil.getLiteralMes(Number.parseInt(data.split('-')[1]))
      return literalMes.toLocaleUpperCase().substr(0, 3) + '/' + data.split('-')[0].substr(2, 2)
    } catch (e) { }
    return ''
  }

  selecionaFiltro(tipoFiltro: String) {
    if (this.filtroEncerradas == tipoFiltro) {
      this.filtroEncerradas = ''
    } else {
      this.filtroEncerradas = tipoFiltro
    }
    this.recomendacoesViewModel.resetOffset()
    this.requisitaPorAba(this.aba, true)
  }

  toggleEncerradas() {
    this.aba = this.TIPO_ENCERRADAS
  }

  async showAlert(title: string, message: string, handler?): Promise<HTMLIonAlertElement> {
    const alert = await AlertComponent.showAlert(title, message, handler)
    return alert
  }

  async showLoading() {
    return await this.loadingComponent.showLoading()
  }

  setListaRecomendacaoCurto(listaCurtoPrazo: Array<RecomendacaoModel>) {
    if (this.requestSwipUp) {
      if (listaCurtoPrazo.length > 0) {
        this.recomendacaoCurto = this.recomendacaoCurto.concat(listaCurtoPrazo)
      }
      this.requestSwipUp = false
    } else {
      this.recomendacaoCurto = listaCurtoPrazo
    }
  }

  setListaRecomendacaoMedio(listaCurtoMedio: Array<RecomendacaoModel>) {
    if (this.requestSwipUp) {
      if (listaCurtoMedio.length > 0) {
        this.recomendacaoMedio = this.recomendacaoMedio.concat(listaCurtoMedio)
      }
      this.requestSwipUp = false
    } else {
      this.recomendacaoMedio = listaCurtoMedio
    }
  }

  setListaRecomendacaoLongo(listaCurtoLongo: Array<RecomendacaoModel>) {
    if (this.requestSwipUp) {
      if (listaCurtoLongo.length > 0) {
        this.recomendacaoLongo = this.recomendacaoLongo.concat(listaCurtoLongo)
      }
      this.requestSwipUp = false
    } else {
      this.recomendacaoLongo = listaCurtoLongo
    }
  }

  setListaRecomendacaoTodas(listaTodas: Array<RecomendacaoModel>) {
    if (this.requestSwipUp) {
      if (listaTodas.length > 0) {
        this.recomendacaoTodas = this.recomendacaoTodas.concat(listaTodas)
      }
      this.requestSwipUp = false
    } else {
      this.recomendacaoTodas = listaTodas
    }
  }

  setListaRecomendacaoEncerrados(listaEncerrados: Array<RecomendacaoModel>) {
    if (this.requestSwipUp) {
      if (listaEncerrados.length > 0) {
        for (let item of listaEncerrados) {
          this.recomendacaoEncerrados.push(item)
        }
      }
      this.requestSwipUp = false
    } else {
      this.recomendacaoEncerrados = listaEncerrados
    }
  }

  async changeSegment() {
    this.recomendacoesViewModel.resetOffset()
    await this.requisitaPorAba(this.aba)
    this.changeDetectorRef.detectChanges();
  }

  getListaCodigoAtivos(): Array<String> {
    let aux: Array<String> = []
    this.listaAnaliseAtivosView.forEach((item) => {
      item.forEach((a) => {
        aux.push(a.codigo_ativo)
      })
    })
    return aux
  }

  async requisitaPorAba(aba: string, novaRequisicao: boolean = false) {
    let loading = null;
    console.log(this.tipoAtivo);

    try {
      loading = await this.showLoading()

      await this.recomendacoesViewModel.setPreferenciaUsuario(this.tipoAtivo)
      this.location.replaceState(`/navigation/recomendacoes/${this.tipoAtivo}`);
      this.tituloPagina = Recomedacoes[this.tipoAtivo.toString()]
      this.favoritos = await this.recomendacoesViewModel.getListaFavoritos(this.tipoAtivo)
      
      switch (aba) {
        case this.TIPO_CURTO:
          this.idTipoRecomendacao = Tipos[aba]
          if (this.recomendacaoCurto.length <= 0 || novaRequisicao) {
            await this.recomendacoesViewModel.getRecomedacoesCurtoPrazo(this.tipoAtivo, this.idTipoRecomendacao)
            this.primeiraRequisicao[0] = true
            this.listaAnaliseAtivosView[0] = this.listMergeFavoriteWithRecomendations(this.recomendacaoCurto, this.favoritos)
            this.recomendacaoCurto.length > 0 && this.mapAll()
          }
          break;
        case this.TIPO_MEDIO:
          this.idTipoRecomendacao = Tipos[aba]
          if (this.recomendacaoMedio.length <= 0 || novaRequisicao) {
            await this.recomendacoesViewModel.getRecomedacoesMedioPrazo(this.tipoAtivo, this.idTipoRecomendacao)
            this.primeiraRequisicao[1] = true
            this.listaAnaliseAtivosView[1] = this.listMergeFavoriteWithRecomendations(this.recomendacaoMedio, this.favoritos)
            this.recomendacaoMedio.length > 0 && this.mapAll()
          }
          break;
        case this.TIPO_LONGO:
          this.idTipoRecomendacao = Tipos[aba]
          if (this.recomendacaoLongo.length <= 0 || novaRequisicao) {
            await this.recomendacoesViewModel.getRecomedacoesLongoPrazo(this.tipoAtivo, this.idTipoRecomendacao)
            this.primeiraRequisicao[2] = true
            this.listaAnaliseAtivosView[2] = this.listMergeFavoriteWithRecomendations(this.recomendacaoLongo, this.favoritos)
            this.recomendacaoLongo.length > 0 && this.mapAll()
          }
          break;
        case this.TIPO_TODAS:
          this.idTipoRecomendacao = Tipos[aba]
          if (this.recomendacaoTodas.length <= 0 || novaRequisicao) {
            await this.recomendacoesViewModel.getRecomedacoesTodas(this.tipoAtivo)
            this.primeiraRequisicao[3] = true
            this.listaAnaliseAtivosView[3] = this.listMergeFavoriteWithRecomendations(this.recomendacaoTodas, this.favoritos)
            this.recomendacaoTodas.length > 0 && this.mapAll()
          }
          break;
        case this.TIPO_ENCERRADAS:
          if (this.recomendacaoEncerrados.length <= 0 || novaRequisicao) {
            await this.recomendacoesViewModel.getRecomedacoesEncerradasTodas(this.tipoAtivo)
            this.primeiraRequisicao[4] = true
            this.listaAnaliseAtivosView[4] = this.recomendacaoEncerrados
            this.recomendacaoEncerrados.length > 0 && this.mapAll()
          }
          break;
      }


    } catch (e) {
      this.showAlert(ThrowError.TITLE_DEFAULT, 'Não foi possível obter a listagem de recomendações. Tente novamente')
    }
    if (loading != null) {
      loading.dismiss()
    }
  }

  listMergeFavoriteWithRecomendations(listRecomendations, listFavorites) {
    const listTemp = []
    const favoritosTemp = []
    listRecomendations.forEach(item => {
      if (listFavorites.indexOf(item.id) >= 0) {
        item.favorito = true
        favoritosTemp.push(item)
      } else {
        listTemp.push(item)
      }
    })
    return [...favoritosTemp, ...listTemp]
  }

  getTargetAchieved(ativo) {
    if (!ativo.objetivos) return
    let alvo = null
    ativo.objetivos.forEach(item => {
      if (item.atingido) alvo = item
    });
    return alvo
  }

  async mapAll() {
    let mapTemp = {}

    for (let i = 0; i < this.listaAnaliseAtivosView.length; i++) {
      for (let j = 0; j < this.listaAnaliseAtivosView[i].length; j++) {
        mapTemp[this.listaAnaliseAtivosView[i][j].codigo_ativo.toString()] = {
          lista: i,
          indice: j
        }
      }
    }

    this.listaAnaliseAtivosViewMap = { ...mapTemp }

    await this.handlerStartWebSocket(false)
  }

  async swipDown(event) {
    this.recomendacoesViewModel.resetOffset()
    await this.requisitaPorAba(this.aba, true)
    event.target.complete();
  }

  openMenu() {
    this.menuCtrl.enable(true, 'first');
    this.menuCtrl.open('first');
  }

  async swipUp(event) {
    setTimeout(async () => {      
      this.requestSwipUp = true
      this.recomendacoesViewModel.addOffset()
      await this.requisitaPorAba(this.aba, true)
      this.virtualScroll.checkEnd();
      this.infiniteScroll.complete();
    }, 1000);
  }

  toggleInfiniteScroll() {
    this.infiniteScroll.disabled = !this.infiniteScroll.disabled;
  }

  limpaNotificacoesLocal() {
    AppStorage.remove(AppSession.CHAVE_LISTA_NOTIFICACOES);
  }

  verificaPermissaoFeature(contrato: any) {
    return ContratoModel.verificaMenuLiberadoPorContrato(contrato, this.contratoWrapper.contratos)
  }

  exibeDialogPlano() {
    HelperMenuContrato.navegaTelaPlanos(this.contratoWrapper.url_contratar)
  }

  resetAll() {
    this.aba = this.TIPO_TODAS
    this.recomendacoesViewModel.resetOffset()

    this.listaAnaliseAtivosView[0] = []
    this.listaAnaliseAtivosView[1] = []
    this.listaAnaliseAtivosView[2] = []
    this.listaAnaliseAtivosView[3] = []
    this.listaAnaliseAtivosView[4] = []

    this.recomendacaoCurto = []
    this.recomendacaoMedio = []
    this.recomendacaoLongo = []
    this.recomendacaoTodas = []
    this.recomendacaoEncerrados = []
    this.primeiraRequisicao = [false, false, false, false, false]
  }

  async presentActionSheet() {
    let buttons = [{
      text: 'Ações Brasil',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature(this.constanteContrato[0])) {
          this.exibeDialogPlano()
        } else {
          this.resetAll()
          this.tipoAtivo = RecomendacaoMenuModel.TIPO_ACOES_BOLSA
          this.tituloPagina = Recomedacoes[RecomendacaoMenuModel.TIPO_ACOES_BOLSA]
          this.requisitaPorAba(this.aba, true)
        }
      }
    }, {
      text: 'Opções',
      cssClass: 'btn-action-sheet',
      handler: () => {
        debugger
        if (!this.verificaPermissaoFeature({
          tipoAtivo: RecomendacaoMenuModel.TIPO_ACOES_BOLSA,
          chaveContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_OPCOES_BRASIL]
        })) {
          this.exibeDialogPlano()
        } else {
          this.resetAll();
          this.openPage('navigation/recomendacoes-opcoes/B')
        }
      }
    }, {
      text: 'Criptoativos',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature(this.constanteContrato[2])) {
          this.exibeDialogPlano()
        } else {
          this.resetAll();
          this.tipoAtivo = RecomendacaoMenuModel.TIPO_CRIPTOMOEDAS
          this.tituloPagina = Recomedacoes[RecomendacaoMenuModel.TIPO_CRIPTOMOEDAS]
          this.requisitaPorAba(this.aba, true)
        }
      }
    }, {
      text: 'Ações EUA',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature(this.constanteContrato[1])) {
          this.exibeDialogPlano()
        } else {
          this.resetAll();
          this.tipoAtivo = RecomendacaoMenuModel.TIPO_EUA
          this.tituloPagina = Recomedacoes[RecomendacaoMenuModel.TIPO_EUA]
          this.requisitaPorAba(this.aba, true)
        }
      }
    }, {
      text: 'BDRs',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature(this.constanteContrato[6])) {
          this.exibeDialogPlano()
        } else {
          this.resetAll();
          this.tipoAtivo = RecomendacaoMenuModel.TIPO_BDR
          this.tituloPagina = Recomedacoes[RecomendacaoMenuModel.TIPO_BDR]
          this.requisitaPorAba(this.aba, true)
        }
      }
    }/*, {
      text: 'Fundos Imobiliários (FIIs)',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature(this.constanteContrato[3])) {
          this.exibeDialogPlano()
        } else {
          this.resetAll();
          this.tipoAtivo = RecomendacaoMenuModel.TIPO_FUNDOS_IMOBILIARIOS
          this.tituloPagina = Recomedacoes[RecomendacaoMenuModel.TIPO_FUNDOS_IMOBILIARIOS]
          this.requisitaPorAba(this.aba, true)
        }
      }
    }, {
      text: 'Fundos de Índices (ETFs)',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature(this.constanteContrato[4])) {
          this.exibeDialogPlano()
        } else {
          this.resetAll();
          this.tipoAtivo = RecomendacaoMenuModel.TIPO_FUNDOS_INDICE
          this.tituloPagina = Recomedacoes[RecomendacaoMenuModel.TIPO_FUNDOS_INDICE]
          this.requisitaPorAba(this.aba, true)
        }
      }
    }, {
      text: 'Índices Setoriais',
      cssClass: 'btn-action-sheet',
      handler: () => {
        if (!this.verificaPermissaoFeature(this.constanteContrato[5])) {
          this.exibeDialogPlano()
        } else {
          this.resetAll();
          this.tipoAtivo = RecomendacaoMenuModel.TIPO_INDICES
          this.tituloPagina = Recomedacoes[RecomendacaoMenuModel.TIPO_INDICES]
          this.requisitaPorAba(this.aba, true)
        }
      }
    }*/, {
      text: 'Cancelar',
      role: 'cancel',
      cssClass: 'btn-action-sheet',
      handler: () => {
        console.log('Cancel clicked');
      }
    }]

    const actionSheet = await this.actionSheetController.create({
      header: "Tipo de seleção",
      mode: 'ios',
      buttons
    });

    await actionSheet.present();

    this.handleOpenDrawer();
  }
}
